import React from "react";
import { ClipboardList } from "lucide-react";
import { arClass } from "../../../utils/useArClass";

const WaitingRoomHeader = ({ Text }) => {
  return (
    <div
      className={arClass(
        "flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between",
      )}
    >
      <h1
        className={arClass(
          "text-2xl sm:text-3xl font-bold flex items-center gap-3 max-sm:text-lg",
        )}
      >
        <span
          className={arClass(
            "inline-flex items-center justify-center w-10 h-10 rounded-xl bg-medical-500/10 text-medical-600",
          )}
        >
          <ClipboardList size={20} />
        </span>
        <Text>smartWaitingRoom</Text>
      </h1>
    </div>
  );
};

export default WaitingRoomHeader;
